import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=13519b40&scoped=true&"
import script from "./Expired.js?vue&type=script&lang=js&"
export * from "./Expired.js?vue&type=script&lang=js&"
import style0 from "./Expired.vue?vue&type=style&index=0&id=13519b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13519b40",
  null
  
)

export default component.exports